import lang from "@/views/modules/Notifications/language/en";
import loader from "@/views/shared/loading/Loading.vue";
import breadcrumbs from "@/views/modules/Applications/MenuList.vue";
import alert from "@/views/shared/notify/Alert.vue";


export default {
    name: "list-notifications",
    components: {
        loader,
        breadcrumbs,
        alert
    },
    data() {
        return {
            page: 1,
            search: '',
            sort: {
                order: 'DESC',
                column: 'date_entered',
                relRef: '',
            },
            perPage: 10,
            loading: true,
            notificationList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            lang: [],
            table_head: [{
                label: lang.LBL_DESCRIPTION,
                isSort: true,
                field_name: 'description'
            },
            {
                label: lang.LBL_SEND_BY,
                relRef: 'notifications_users',
                isSort: true,
                field_name: 'name'
            },
            {
                label: lang.LBL_DATE,
                isSort: true,
                field_name: 'date_entered'
            },
            {
                label: lang.LBL_RELETED,
                isSort: true,
                field_name: 'parent_type'
            },
            {
                label: lang.LBL_READ,
                isSort: true,
                field_name: 'read'
            },
            {
                label: lang.LBL_MARK_READ,
                isSort: false,
                field_name: 'id'
            },
            {
                label: lang.LBL_DETAIL,
            }
            ]
        }
    },
    mounted() {
        this.getNotifications();
        this.lang = lang;
    },
    methods: {
        sortBy(field, relRef) {
            if (this.sort.column === field) {
                this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.sort.order = 'asc';
            }
            this.sort.column = field;
            this.sort.relRef = relRef;
            this.getNotifications()
        },
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.getNotifications();
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.getNotifications();
        },
        getNotifications(search = '') {
            const self = this;
            self.loading = true;
            const storedFilters = localStorage.getItem('filters');
            if (storedFilters !== '') {
                self.search = storedFilters;
            }
            if (search != '') {
                self.search = search;
            }
             window.currentAction = 'list';
                axios.get('api/modules/notifications', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                self.notificationList = response.data.items;
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getNotifications();
                } else {
                    self.loading = false;
                }
            }).catch(function () {
                self.loading = false;
            });
        },

        markAsRead(rowid){
            const self = this;
            let new_value = document.getElementById("no_td"+rowid).innerHTML;
            //console.log(new_value);
            axios.post('api/modules/notifications/updatenotification', {'record_id':rowid, value:new_value}).then(function(response){
                //self.getNotifications();
                
                if(new_value == 'No')
                {
                    if(document.getElementById("no_btn"+rowid))
                    {
                        document.getElementById("no_btn"+rowid).innerHTML = 'Read';
                        let btnEl = document.getElementById("no_btn"+rowid);
                        btnEl.classList.remove("btn-primary");
                        btnEl.classList.add("btn-success");
                    }
                    if(document.getElementById("yes_btn"+rowid))
                    {
                        document.getElementById("yes_btn"+rowid).innerHTML = 'Read';
                        let btnEl = document.getElementById("yes_btn"+rowid);
                        btnEl.classList.remove("btn-primary");
                        btnEl.classList.add("btn-success");
                    }
                
                
                document.getElementById("no_td"+rowid).innerHTML = 'Yes';
                }

                if(new_value == 'Yes')
                {
                    if(document.getElementById("yes_btn"+rowid))
                    {
                        document.getElementById("yes_btn"+rowid).innerHTML = 'Unread';
                        let btnEl = document.getElementById("yes_btn"+rowid);
                        btnEl.classList.remove("btn-success");
                        btnEl.classList.add("btn-primary");
                    }
                    if(document.getElementById("no_btn"+rowid))
                    {
                        document.getElementById("no_btn"+rowid).innerHTML = 'Unread';
                        let btnEl = document.getElementById("no_btn"+rowid);
                        btnEl.classList.remove("btn-success");
                        btnEl.classList.add("btn-primary");
                    }
                
                document.getElementById("no_td"+rowid).innerHTML = 'No';
                }
            }).catch(error => {
                console.log(error);
            })
        },
        openPage(url, parent){
            if(parent == 'Applications' || parent == 'Applications')
            {            
                this.$refs.notifyMsg.showAlert('Information','To view the document, Click on the reviewer document tab on the next screen', url);
                //this.$router.push(url);
            }else{
                this.$router.push(url);
            }
        }
    }
}